import { Flatfile } from '@flatfile/api';
import { TENANT_TYPES, CHANNEL_TYPE_KEYS } from 'constants-channel';

const tenantTypeOptions = TENANT_TYPES.filter(
  type =>
    type !== CHANNEL_TYPE_KEYS.Professional &&
    type !== CHANNEL_TYPE_KEYS.Charity
).map(type => ({
  value: type,
  label: type,
}));

export const workbook: Flatfile.CreateWorkbookConfig = {
  name: 'Import Tenants',
  labels: ['pinned'],
  sheets: [
    {
      name: 'Tenants',
      slug: 'tenants',
      fields: [
        {
          key: 'name',
          type: 'string',
          label: 'Tenant Name',
          constraints: [{ type: 'required' }, { type: 'unique' }],
        },
        {
          key: 'displayName',
          type: 'string',
          label: 'Tenant Display Name',
        },
        {
          key: 'tenantType',
          type: 'enum',
          label: 'Tenant Type',
          constraints: [{ type: 'required' }],
          config: {
            options: tenantTypeOptions,
          },
        },
        {
          key: 'suites',
          type: 'string',
          label: 'Suites',
          description:
            'Comma-separated suites numbers (e.g., Suite 100, Suite 200). If a suites does not exist, a new one will be created.',
        },
        {
          key: 'externalLeaseId',
          type: 'string',
          label: 'External Lease ID',
          description:
            'Comma-separated lease IDs (e.g., LEASE-001, LEASE-002). Required only if Suites is provided. Count must be equal to or less than Suites count.',
        },
        {
          key: 'sourceType',
          type: 'string',
          label: 'External Source Type',
          description:
            'Comma-separated source types (e.g., Yardi, MRI, CBRE). Valid values: CBRE, MRI, SFDC, VCM, Yardi. Required if External Lease ID is provided, and count must match Lease ID count.',
        },
        {
          key: 'whiteListedEmailDomains',
          type: 'string',
          label: 'Whitelisted Email Domains',
          description:
            'Comma-separated list of email domains (e.g., example.com, sub.example.com)',
        },
      ],
    },
  ],
  actions: [
    {
      operation: 'submitActionFg',
      mode: 'foreground',
      label: 'Submit',
      description: 'Submit tenant data',
      primary: true,
      constraints: [{ type: 'hasAllValid' }, { type: 'hasData' }],
    },
  ],
};
